import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import clockicon from '../../assets/images/clock-icon.svg';


const Addappointment = () => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    return (
        <>
            <Button variant="primary" onClick={handleShow}>
                Launch demo modal
            </Button>

           <Modal className='custom_popup' centered>
                <Modal.Header closeButton>
                    <Modal.Title>Modal heading</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group className="filled_input" controlId="exampleForm.ControlInput1">
                            <Form.Label>Add Tittle</Form.Label>
                            <Form.Control type="text" placeholder="Enter tittle" />
                        </Form.Group>
                        <div className="row">
                            <div className="col-md-6">
                                <Form.Group className="filled_input" controlId="exampleForm.ControlInput1">
                                    <Form.Label>From Time</Form.Label>
                                    <div className="filled_input_icon">
                                        <Form.Control type="text" placeholder="Select time" />
                                        <img className="icon_img" src={clockicon} alt="clockicon" />
                                    </div>
                                </Form.Group>
                            </div>
                            <div className="col-md-6">
                                <Form.Group className="filled_input" controlId="exampleForm.ControlInput1">
                                    <Form.Label>To Time</Form.Label>
                                    <div className="filled_input_icon">
                                        <Form.Control type="time" placeholder="Select time" />
                                        <img className='icon_img' src={clockicon} alt="clockicon" />
                                    </div>
                                </Form.Group>
                            </div>
                            <div className="col-md-6">
                                <Form.Group className="filled_input" controlId="exampleForm.ControlInput1">
                                    <Form.Label>Location</Form.Label>
                                    <Form.Control type="text" placeholder="Enter location" />
                                </Form.Group>
                            </div>
                            <div className="col-md-6">
                                <Form.Group className="filled_input" controlId="exampleForm.ControlInput1">
                                    <Form.Label>Meeting</Form.Label>
                                    <Form.Control type="text" placeholder="Enter meeting" />
                                </Form.Group>
                            </div>
                        </div>
                        <Form.Group className="filled_input" controlId="exampleForm.ControlInput1">
                            <Form.Label>Meeting Participants</Form.Label>
                        </Form.Group>
                        <Form.Group className="filled_input filled_textarea mb-0" controlId="exampleForm.ControlTextarea1">
                            <Form.Label>Enter description</Form.Label>
                            <Form.Control as="textarea" rows={3} placeholder='Enter description' />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary">
                        Cancel
                    </Button>
                    <Button variant="primary">
                        Join
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default Addappointment;